import {Component, OnInit} from '@angular/core';
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {ConstantsService} from "../ConstantsService";
import {FiadosService} from "../../services/fiados.service";
import {FormasDePagamentoService} from "../../services/formas-de-pagamento.service";
import {ModalAcertoFiadoComponent} from "../modal-acerto-fiado/modal-acerto-fiado.component";
import {ModalCreditoFiadoComponent} from "../modal-credito-fiado/modal-credito-fiado.component";
import {FiadoFormaPagamentoUtils} from "../fiado-forma-pagamento.utils";
import {ActivatedRoute} from "@angular/router";
import {Router} from "@angular/router";
import {ContatosService} from "../../services/contatos.service";

declare var moment;

@Component({
  selector: 'app-tela-fiados',
  templateUrl: './tela-fiados.component.html',
  styleUrls: ['./tela-fiados.component.scss']
})
export class TelaFiadosComponent implements OnInit {
  empresa: any;
  carregando = false;
  carregandoAcertos = false;
  erro = '';
  abaAtiva: 'abertos' | 'acertos' = 'abertos';
  filtro: any = {
    q: '',
    t: 100,
    todos: false,
    di: null,
    df: null,
    idContato: null
  };
  resposta: any = {
    lancamentos: [],
    pedidos: [],
    total: 0
  };
  respostaAcertos: any = {
    acertos: [],
    total: 0
  };
  agrupadoPorContato: any[] = [];
  formasDePagamento: any[] = [];
  detalhesAcertos: {[id: number]: any} = {};
  detalhesAcertosCarregando: {[id: number]: boolean} = {};
  totalPaginasLancamentos = 1;
  totalPaginasAcertos = 1;
  inicioLancamentos = 0;
  inicioAcertos = 0;
  moduloFiadoAtivo = false;
  grupoTodosPedidos: any = null;
  buscaTodosPedidos = '';
  contatoFiltro: any = null;
  carregandoContatoFiltro = false;
  readonly tamanhosPagina = [25, 50, 100];

  constructor(private constantsService: ConstantsService,
              private fiadosService: FiadosService,
              private formasDePagamentoService: FormasDePagamentoService,
              private dialogService: DialogService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private contatosService: ContatosService) {}

  ngOnInit(): void {
    this.apliqueFiltrosDaRota(this.activatedRoute.snapshot.queryParams, false);

    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.apliqueFiltrosDaRota(params);
    });

    this.constantsService.empresa$.subscribe((empresa: any) => {
      if(!empresa) return;

      this.empresa = empresa;
      this.moduloFiadoAtivo = this.constantsService.possuiModulo(empresa, 'controle fiado');
      if(!this.moduloFiadoAtivo) {
        this.erro = 'Módulo Fiado não está ativo para esta empresa.';
        this.router.navigateByUrl('/admin/pedidos').then(() => {});
        return;
      }
      this.carregueFormasDePagamento();
      this.apliqueFiltrosDaRota(this.activatedRoute.snapshot.queryParams, false);
      this.carregueLancamentos();
      this.carregueAcertos();
    });
  }

  private apliqueFiltrosDaRota(params: any = {}, recarregar: boolean = true) {
    const idContato = params.idContato != null && params.idContato !== '' ? Number(params.idContato) : null;
    const q = params.q || '';
    const alterouFiltro = this.filtro.idContato !== idContato || this.filtro.q !== q;

    this.filtro.idContato = idContato;
    this.filtro.q = q;
    this.sincronizeContatoFiltro();

    if(!recarregar || !alterouFiltro || !this.empresa || !this.moduloFiadoAtivo) return;

    this.inicioLancamentos = 0;
    this.inicioAcertos = 0;
    this.carregueLancamentos();
    this.carregueAcertos();
  }

  carregueFormasDePagamento() {
    this.formasDePagamento = [...(this.empresa?.formasDePagamento || [])]
      .filter((forma: any) => FiadoFormaPagamentoUtils.formaPermitidaParaRecebimento(forma));

    if(!this.formasDePagamento.length && this.empresa?.id) {
      this.formasDePagamentoService.obtenhaFormasDePagamentos(this.empresa).then((formas: any[]) => {
        this.formasDePagamento = (formas || []).filter((forma: any) => FiadoFormaPagamentoUtils.formaPermitidaParaRecebimento(forma));
      }).catch(() => {});
    }
  }

  carregueLancamentos() {
    this.carregando = true;
    this.erro = '';

    this.fiadosService.listeLancamentos({...this.filtro, i: this.inicioLancamentos}).then((resposta: any) => {
      this.carregando = false;
      this.resposta = resposta || {lancamentos: [], total: 0};
      this.resposta.lancamentos = this.obtenhaLancamentosVisiveis(this.resposta.lancamentos || []);
      if(!this.filtro.todos) this.resposta.total = this.resposta.lancamentos.length;
      this.totalPaginasLancamentos = Math.max(1, Math.ceil((this.resposta.total || 0) / this.filtro.t));
      this.agrupeLancamentosPorContato();
      this.apliqueContatoFiltroDosResultados();
    }).catch((erro: any) => {
      this.carregando = false;
      this.erro = erro;
    });
  }

  carregueAcertos() {
    this.carregandoAcertos = true;
    this.erro = '';

    this.fiadosService.listeAcertos({...this.filtro, i: this.inicioAcertos}).then((resposta: any) => {
      this.carregandoAcertos = false;
      this.respostaAcertos = resposta || {acertos: [], total: 0};
      this.totalPaginasAcertos = Math.max(1, Math.ceil((this.respostaAcertos.total || 0) / this.filtro.t));
    }).catch((erro: any) => {
      this.carregandoAcertos = false;
      this.erro = erro;
    });
  }

  agrupeLancamentosPorContato() {
    const grupos: any = {};

    (this.resposta.lancamentos || []).forEach((lancamento: any) => {
      const contato = lancamento.contato || {};
      const idContato = this.obtenhaIdContatoLancamento(lancamento);
      const chave = idContato ? String(idContato) : `sem-contato-${lancamento.id || lancamento?.pedido?.id || lancamento?.pedido?.codigo}`;

      if(!grupos[chave]) {
        grupos[chave] = {
          contato: contato,
          lancamentos: [],
          totalSaldo: 0,
          totalOriginal: 0
        };
      }

      grupos[chave].lancamentos.push(lancamento);
      grupos[chave].totalSaldo += Number(lancamento.saldo || 0);
      grupos[chave].totalOriginal += Number(lancamento.valorOriginal || 0);
    });

    this.agrupadoPorContato = Object.values(grupos);
  }

  abraModalAcerto(grupo: any) {
    this.fecheModalTodosPedidos();

    const idContato = Number(grupo?.contato?.id || 0);
    const lancamentosDoGrupo = grupo?.lancamentos || [];
    const lancamentos = (grupo?.lancamentos || [])
      .filter((item: any) => this.obtenhaIdContatoLancamento(item) === idContato && this.lancamentoEmAberto(item));
    const possuiLancamentoDeOutroCliente = lancamentosDoGrupo
      .some((item: any) => this.obtenhaIdContatoLancamento(item) !== idContato);

    if(!idContato || possuiLancamentoDeOutroCliente) {
      this.erro = 'Há lançamentos inconsistentes para este cliente. Recarregue a tela e faça o acerto apenas com pedidos do mesmo cliente.';
      return;
    }

    if(!lancamentos.length) {
      this.erro = 'Este cliente não possui pedidos em aberto para acerto.';
      return;
    }

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalAcertoFiadoComponent,
      width: window.innerWidth > 1320 ? 1260 : window.innerWidth - 40,
      maxHeight: window.innerHeight - 80,
      cssClass: 'bsModal modal-acerto-fiado-dialog'
    });

    const instancia: ModalAcertoFiadoComponent = windowRef.content.instance;
    instancia.window = windowRef;
    instancia.contato = grupo.contato;
    instancia.lancamentos = lancamentos.map((item: any) => ({...item}));
    instancia.formasDePagamento = this.formasDePagamento;

    windowRef.result.subscribe((result: any) => {
      if(result && result.id) {
        this.carregueLancamentos();
        this.carregueAcertos();
      }
    });
  }

  abraModalCredito(grupo: any) {
    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalCreditoFiadoComponent,
      width: window.innerWidth > 760 ? 700 : window.innerWidth - 20,
      maxHeight: window.innerHeight - 80,
      cssClass: 'bsModal'
    });

    const instancia: ModalCreditoFiadoComponent = windowRef.content.instance;
    instancia.window = windowRef;
    instancia.contato = grupo.contato;
    instancia.formasDePagamento = this.formasDePagamento;

    windowRef.result.subscribe((result: any) => {
      if(result && result.id) {
        this.carregueLancamentos();
        this.carregueAcertos();
      }
    });
  }

  selecioneAba(aba: 'abertos' | 'acertos') {
    this.abaAtiva = aba;
  }

  filtrar() {
    this.inicioLancamentos = 0;
    this.inicioAcertos = 0;
    this.carregueLancamentos();
    this.carregueAcertos();
  }

  alterePagina(delta: number, tipo: 'lancamentos' | 'acertos') {
    const proximoInicio = Math.max(0, Number((tipo === 'lancamentos' ? this.inicioLancamentos : this.inicioAcertos) || 0)
      + delta * Number(this.filtro.t || 100));

    if(tipo === 'lancamentos') {
      this.inicioLancamentos = proximoInicio;
      this.carregueLancamentos();
    } else {
      this.inicioAcertos = proximoInicio;
      this.carregueAcertos();
    }
  }

  paginaAtual(tipo: 'lancamentos' | 'acertos') {
    const inicio = tipo === 'lancamentos' ? this.inicioLancamentos : this.inicioAcertos;
    return Math.floor(Number(inicio || 0) / Number(this.filtro.t || 100)) + 1;
  }

  altereTamanhoPagina() {
    this.inicioLancamentos = 0;
    this.inicioAcertos = 0;
    this.carregueLancamentos();
    this.carregueAcertos();
  }

  toggleDetalhesAcerto(acerto: any) {
    if(this.detalhesAcertos[acerto.id]) {
      delete this.detalhesAcertos[acerto.id];
      return;
    }

    this.detalhesAcertosCarregando[acerto.id] = true;
    this.fiadosService.obtenhaAcerto(acerto.id).then((resposta: any) => {
      this.detalhesAcertosCarregando[acerto.id] = false;
      this.detalhesAcertos[acerto.id] = resposta;
    }).catch(() => {
      this.detalhesAcertosCarregando[acerto.id] = false;
    });
  }

  formatarData(data: any) {
    if(!data) return '-';
    return moment(data).format('DD/MM/YYYY HH:mm');
  }

  limpeFiltros() {
    this.filtro = {
      q: '',
      t: this.filtro?.t || 100,
      todos: false,
      di: null,
      df: null,
      idContato: null
    };
    this.filtrar();
  }

  limpeFiltroContato() {
    this.contatoFiltro = null;
    this.filtro.idContato = null;
    this.inicioLancamentos = 0;
    this.inicioAcertos = 0;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {idContato: null},
      queryParamsHandling: 'merge'
    }).then(() => {
      this.carregueLancamentos();
      this.carregueAcertos();
    });
  }

  temFiltroContato() {
    return Number(this.filtro?.idContato || 0) > 0;
  }

  obtenhaLabelContatoFiltro() {
    if(this.carregandoContatoFiltro) return 'Carregando cliente...';
    if(this.contatoFiltro?.nome) return this.contatoFiltro.nome;
    return `Cliente #${this.filtro.idContato}`;
  }

  obtenhaTotalEmAberto() {
    return this.agrupadoPorContato.reduce((total: number, grupo: any) => total + Number(grupo.totalSaldo || 0), 0);
  }

  obtenhaQtdeClientesComSaldo() {
    return this.agrupadoPorContato.length;
  }

  obtenhaQtdePedidosEmAberto() {
    return (this.resposta?.lancamentos || []).length;
  }

  obtenhaLabelStatus(status: string) {
    if(!status) return '-';
    const texto = String(status).toLowerCase();
    return texto.charAt(0).toUpperCase() + texto.slice(1);
  }

  obtenhaIniciais(nome: string) {
    const partes = String(nome || '')
      .trim()
      .split(/\s+/)
      .filter((parte: string) => !!parte);

    if(!partes.length) return '-';
    return partes.slice(0, 2).map((parte: string) => parte.charAt(0).toUpperCase()).join('');
  }

  obtenhaLinkContato(contato: any) {
    if(!contato) return '/admin/contatos';

    if(contato.telefone)
      return `/admin/contatos/${contato.codigoPais || ''}${contato.telefone}`;

    if(contato.cpf || contato.cnpj)
      return `/admin/contatos/documento/${contato.cpf || contato.cnpj}`;

    if(contato.id)
      return `/admin/contatos/id/${contato.id}`;

    return '/admin/contatos';
  }

  private sincronizeContatoFiltro() {
    const idContato = Number(this.filtro?.idContato || 0);
    if(!idContato) {
      this.contatoFiltro = null;
      this.carregandoContatoFiltro = false;
      return;
    }

    if(Number(this.contatoFiltro?.id || 0) === idContato) return;

    this.contatoFiltro = {id: idContato};
    this.carregandoContatoFiltro = true;
    this.contatosService.obtenhaContatoPorId(String(idContato)).then((contato: any) => {
      this.carregandoContatoFiltro = false;
      if(Number(this.filtro?.idContato || 0) === idContato)
        this.contatoFiltro = contato || {id: idContato};
    }).catch(() => {
      this.carregandoContatoFiltro = false;
    });
  }

  private apliqueContatoFiltroDosResultados() {
    if(!this.temFiltroContato() || this.contatoFiltro?.nome) return;

    const grupo = (this.agrupadoPorContato || [])
      .find((item: any) => Number(item?.contato?.id || 0) === Number(this.filtro.idContato));
    if(grupo?.contato?.id)
      this.contatoFiltro = grupo.contato;
  }

  obtenhaUltimosLancamentos(grupo: any) {
    return (grupo?.lancamentos || []).slice(0, 3);
  }

  abraModalTodosPedidos(grupo: any) {
    this.grupoTodosPedidos = grupo;
    this.buscaTodosPedidos = '';
  }

  fecheModalTodosPedidos() {
    this.grupoTodosPedidos = null;
    this.buscaTodosPedidos = '';
  }

  obtenhaLancamentosTodosPedidos() {
    const termo = String(this.buscaTodosPedidos || '').trim().toLowerCase();
    const lancamentos = this.grupoTodosPedidos?.lancamentos || [];

    if(!termo) return lancamentos;

    return lancamentos.filter((item: any) => {
      const codigo = String(item?.pedido?.codigo || '').toLowerCase();
      const status = String(item?.status || '').toLowerCase();
      return codigo.includes(termo) || status.includes(termo);
    });
  }

  trackByGrupo(_: number, grupo: any) {
    return grupo?.contato?.id || grupo?.contato?.nome || _;
  }

  trackByLancamento(_: number, lancamento: any) {
    return lancamento?.id || lancamento?.pedido?.id || lancamento?.pedido?.guid || _;
  }

  trackByAcerto(_: number, acerto: any) {
    return acerto?.id || _;
  }

  inicioExibicao(tipo: 'lancamentos' | 'acertos') {
    const total = tipo === 'lancamentos' ? Number(this.resposta?.total || 0) : Number(this.respostaAcertos?.total || 0);
    if(!total) return 0;

    const inicio = tipo === 'lancamentos' ? this.inicioLancamentos : this.inicioAcertos;
    return Number(inicio || 0) + 1;
  }

  fimExibicao(tipo: 'lancamentos' | 'acertos') {
    const total = tipo === 'lancamentos' ? Number(this.resposta?.total || 0) : Number(this.respostaAcertos?.total || 0);
    if(!total) return 0;

    const inicio = tipo === 'lancamentos' ? this.inicioLancamentos : this.inicioAcertos;
    return Math.min(Number(inicio || 0) + Number(this.filtro.t || 100), total);
  }

  temLancamentos() {
    return this.agrupadoPorContato.length > 0;
  }

  temAcertos() {
    return (this.respostaAcertos?.acertos || []).length > 0;
  }

  obtenhaAcertos() {
    return this.respostaAcertos?.acertos || [];
  }

  obtenhaTotalAcertos() {
    return Number(this.respostaAcertos?.total || 0);
  }

  detalheAcertoVisivel(acerto: any) {
    return this.detalhesAcertosCarregando[acerto.id] || this.detalhesAcertos[acerto.id];
  }

  obtenhaSaldoConta(grupo: any) {
    return Number(grupo?.contato?.contaFinanceira?.saldo || 0);
  }

  obtenhaClasseSaldoConta(grupo: any) {
    const saldo = this.obtenhaSaldoConta(grupo);
    if(saldo > 0) return 'saldo-conta-positivo';
    if(saldo < 0) return 'saldo-conta-negativo';
    return 'saldo-conta-zero';
  }

  possuiCredito(grupo: any) {
    return this.obtenhaSaldoConta(grupo) > 0;
  }

  possuiLancamentoEmAberto(grupo: any) {
    return (grupo?.lancamentos || []).some((item: any) => this.lancamentoEmAberto(item));
  }

  private obtenhaLancamentosVisiveis(lancamentos: any[]) {
    if(this.filtro.todos) return lancamentos || [];

    return (lancamentos || []).filter((item: any) => this.lancamentoEmAberto(item));
  }

  private lancamentoEmAberto(lancamento: any) {
    const status = String(lancamento?.status || '').toLowerCase();
    return (status === 'aberto' || status === 'parcial') && Number(lancamento?.saldo || 0) > 0;
  }

  private obtenhaIdContatoLancamento(lancamento: any) {
    return Number(lancamento?.contato?.id || lancamento?.pedido?.contato?.id || lancamento?.pedido?.cliente?.id || 0);
  }
}
